export default __webpack_public_path__ + "static/media/4_Still.ba149d6c.jpg";